export const normalizeRecipientEmail = (value) => {
    const rawValue = String(value || '').trim();
    if (!rawValue) return '';

    const angleMatch = rawValue.match(/<([^<>]+)>/);
    const emailCandidate = angleMatch?.[1] || rawValue;

    return emailCandidate
        .replace(/^mailto:/i, '')
        .replace(/^['"]+|['"]+$/g, '')
        .trim()
        .toLowerCase();
};

export const normalizeRecipientName = (value) => String(value || '').trim();

export const formatRecipientLabel = (email, fullName = '') => {
    if (!email) return '';
    return fullName ? `${fullName} (${email})` : email;
};

export const buildRecipientOption = (recipient = {}) => {
    const email = normalizeRecipientEmail(recipient?.EMAIL_ID || recipient?.email || recipient?.value);
    const fullName = normalizeRecipientName(recipient?.FULL_NAME || recipient?.fullName);
    const canDeleteValue = recipient?.CAN_DELETE ?? recipient?.canDelete;

    if (!email) return null;

    return {
        id: recipient?.ID || recipient?.id || null,
        value: email,
        label: formatRecipientLabel(email, fullName) || email,
        fullName,
        source: recipient?.SOURCE || recipient?.source || '',
        canDelete: canDeleteValue === true || canDeleteValue === 1 || canDeleteValue === '1',
    };
};

export const mapRecipientOptions = (recipients = []) => {
    return (recipients || []).map(buildRecipientOption).filter(Boolean);
};

export const buildAdhocRecipientOption = (email = '') => {
    const normalizedEmail = normalizeRecipientEmail(email);
    if (!normalizedEmail) return null;

    return {
        value: normalizedEmail,
        label: normalizedEmail,
        fullName: '',
    };
};

export const mergeRecipientOptions = (existing, additions) => {
    const map = new Map();

    (existing || []).forEach((opt) => {
        const normalized = buildRecipientOption(opt);
        if (normalized?.value) {
            map.set(normalized.value, normalized);
        }
    });

    (additions || []).forEach((opt) => {
        const normalized = buildRecipientOption(opt);
        if (normalized?.value && !map.has(normalized.value)) {
            map.set(normalized.value, normalized);
        }
    });

    return Array.from(map.values());
};

export const filterRecipientOption = (candidate, inputValue) => {
    const keyword = String(inputValue || '').trim().toLowerCase();
    if (!keyword) return true;

    const label = String(candidate?.label || '').toLowerCase();
    const value = String(candidate?.value || '').toLowerCase();
    const fullName = String(candidate?.data?.fullName || '').toLowerCase();

    return label.includes(keyword) || value.includes(keyword) || fullName.includes(keyword);
};
